import Grid from '@mui/material/Grid';

import { TopMatterWithDetails } from 'reservations/account/components/TopMatterWithDetails';
import { useHasBrandEngineFeatureFlag } from 'reservations/account/hooks/featureFlags';
import AvailabilitiesConfiguration from 'reservations/availabilities/components/AvailabilitiesConfiguration';
import AvailabilitiesContainer from 'reservations/availabilities/components/AvailabilitiesContainer';
import { AvailabilitiesProvider } from 'reservations/availabilities/providers/AvailabilitiesProvider';
import { FirstAvailableDateProvider } from 'reservations/availabilities/providers/FirstAvailableDateProvider';
import { LayoutWithGutter } from 'reservations/base/components/LayoutWithGutter';
import { useRouteIfAppDisabled } from 'reservations/base/hooks/useRouteIfAppDisabled';
import { useRouteIfReservationsDisabled } from 'reservations/base/hooks/useRouteIfReservationsDisabled';
import BackgroundOverlayImageWrapper from 'reservations/brand/components/BackgroundOverlayImageWrapper';
import { getAvailabilityButtonStyles } from 'reservations/brand/helpers/v1/styles';
import Form from 'reservations/form/components/Form';
import WaitlistProvider from 'reservations/waitlist/providers/WaitlistProvider';

type Props = {
  slug: string;
};

function CreateBooking({ slug }: Props) {
  useRouteIfReservationsDisabled();
  useRouteIfAppDisabled();
  const hasBrandEngineFeature = useHasBrandEngineFeatureFlag();

  return (
    <Form>
      <WaitlistProvider slug={slug}>
        <LayoutWithGutter>
          <Grid container direction="column">
            <Grid item>
              <FirstAvailableDateProvider>
                <AvailabilitiesProvider>
                  <Grid container direction="column" gap="24px">
                    <BackgroundOverlayImageWrapper additionalHeight={150}>
                      <Grid item>
                        <AvailabilitiesConfiguration />
                      </Grid>
                    </BackgroundOverlayImageWrapper>
                    <Grid
                      item
                      sx={getAvailabilityButtonStyles(hasBrandEngineFeature)}
                    >
                      <AvailabilitiesContainer />
                    </Grid>
                  </Grid>
                </AvailabilitiesProvider>
              </FirstAvailableDateProvider>
            </Grid>
          </Grid>
        </LayoutWithGutter>
      </WaitlistProvider>
    </Form>
  );
}

function CreateBookingScreen({ slug }: Props) {
  return (
    <>
      <TopMatterWithDetails />
      <CreateBooking data-testid="create-booking-screen" slug={slug} />
    </>
  );
}

export default CreateBookingScreen;
